import { FC } from 'react';
import { NetworkPointSearch } from 'src/components/domain-specifics/network-points/network-point-search';
import { NetworkPointSearchNew } from 'src/components/domain-specifics/network-points/network-point-search-new';

export const NetworkPointSearchSwitch: FC = () => {
  if (
    PRISMA_CONFIG.stage === 'ent' ||
    PRISMA_CONFIG.stage === 'int' ||
    PRISMA_CONFIG.stage === 'kon' ||
    PRISMA_CONFIG.stage === 'test' ||
    PRISMA_CONFIG.stage === 'prod' ||
    PRISMA_CONFIG.stage === 'storybook' ||
    PRISMA_CONFIG.stage === 'local'
  )
    return <NetworkPointSearchNew />;

  return <NetworkPointSearch />;
};
